import thunk from 'redux-thunk';
import { applyMiddleware, createStore } from 'redux';
import reducer from '../reducers/index.js';
import { composeWithDevTools } from 'redux-devtools-extension';
//import reducerClient from '../reducers/reducerClient';


const store = createStore(reducer, composeWithDevTools(applyMiddleware(thunk))
);
console.log(store.getState());


export default store;